import "@/App.css";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { AppErrorBoundary, SiteProvider } from "./context/SiteContext";
import { AuthProvider } from "./context/AuthContext";
import SiteLayout from "./components/site/SiteLayout";
import { PAGE_COMPONENTS, PAGE_PATHS } from "./pages/pageRegistry";
import { NewsDetail } from "./pages/public/News";
import Preview from "./pages/Preview";
import VirtualJoin from "./pages/public/VirtualJoin";
import TicketCheck from "./pages/public/TicketCheck";
import EventRoom from "./pages/public/EventRoom";
import AdminRoutes from "./pages/admin/AdminRoutes";

const NotFound = () => (
  <div className="container-site py-24" data-testid="not-found-page">
    <h1 className="text-4xl text-navy">Page not found</h1>
    <Link to="/" className="btn-primary mt-6">Back to home</Link>
  </div>
);

function App() {
  return (
    <AppErrorBoundary>
    <BrowserRouter basename={process.env.PUBLIC_URL || ""}>
      <SiteProvider>
        <AuthProvider>
          <TooltipProvider>
            <Routes>
              <Route element={<SiteLayout />}>
                {Object.entries(PAGE_PATHS).map(([slug, path]) => {
                  const Page = PAGE_COMPONENTS[slug];
                  return <Route key={slug} path={path} element={<Page />} />;
                })}
                <Route path="/news/:slug" element={<NewsDetail />} />
                <Route path="/virtual" element={<VirtualJoin />} />
                <Route path="/ticket/:token" element={<TicketCheck />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/preview/:slug" element={<Preview />} />
              <Route path="/event-room" element={<EventRoom />} />
              <Route path="/admin/*" element={<AdminRoutes />} />
            </Routes>
            <Toaster position="top-right" richColors />
          </TooltipProvider>
        </AuthProvider>
      </SiteProvider>
    </BrowserRouter>
    </AppErrorBoundary>
  );
}

export default App;
